import { render } from "./RegionAnalytics.vue?vue&type=template&id=7fc22a00"
import script from "./RegionAnalytics.vue?vue&type=script&lang=js"
export * from "./RegionAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__